import * as React from 'react';
import { TFiltersContext } from './FiltersContext.types';

const FiltersContext = React.createContext<TFiltersContext | undefined>(
  undefined
);

export const FiltersProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [isFiltersOpen, setIsFiltersOpen] = React.useState(false);

  const openFilters = React.useCallback(() => {
    setIsFiltersOpen(true);
  }, []);

  const closeFilters = React.useCallback(() => {
    setIsFiltersOpen(false);
  }, []);

  const value = React.useMemo(
    () => ({
      isFiltersOpen,
      openFilters,
      closeFilters,
    }),
    [isFiltersOpen, openFilters, closeFilters]
  );

  return (
    <FiltersContext.Provider value={value}>{children}</FiltersContext.Provider>
  );
};

export const useFilters = (): TFiltersContext => {
  const context = React.useContext(FiltersContext);
  if (!context) {
    throw new Error('useFilters must be used within FiltersProvider');
  }
  return context;
};
